var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLightRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 44,
    viewBox: "0 0 195 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.444 25.5066H134.011V28.1903H123.419V25.6454C123.419 23.5128 124.404 22.1625 126.536 20.8543L129.493 19.0203C130.364 18.4693 130.915 17.7836 130.915 16.7489C130.915 15.5795 130.066 14.6414 128.555 14.6414C127.134 14.6414 126.217 15.6973 126.217 16.8877H123.398C123.398 14.3638 125.211 11.8442 128.602 11.8442C131.992 11.8442 133.965 14.0441 133.965 16.6353C133.965 18.7217 132.955 20.1182 131.054 21.2666L127.983 23.1216C126.814 23.8535 126.448 24.4508 126.448 25.2753V25.5066H126.444Z",
    fill: "#004659"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7799 12.1386H47.2875V28.1861H51.7799C56.7561 28.1861 59.8268 25.0691 59.8268 20.1603C59.8268 15.2514 56.7561 12.1344 51.7799 12.1344V12.1386ZM51.7799 26.9242H48.684V13.4258H51.7799C55.8139 13.4258 58.384 16.1095 58.384 20.1645C58.384 24.2194 55.7929 26.9284 51.7799 26.9284V26.9242ZM63.2256 12.1386H64.6221V28.1861H63.2256V12.1386ZM78.4065 16.7909C78.4065 13.9726 76.459 12.1386 73.2957 12.1386H68.0251V28.1861H69.4216V21.5358H73.4346L77.1699 28.1861H78.8188L74.8984 21.4012C76.8712 20.9216 78.4065 19.2012 78.4065 16.7951V16.7909ZM73.2957 20.2738H69.4216V13.3963H73.2284C75.6135 13.3963 76.9427 14.8181 76.9427 16.7909C76.9427 19.0371 75.4074 20.2738 73.2957 20.2738ZM83.5594 26.8989H91.2151V28.1819H82.1587V12.1386H91.03V13.4216H83.5552V19.3821H90.0205V20.644H83.5552V26.9031L83.5594 26.8989ZM94.9125 20.1603C94.9125 24.1942 97.8234 27.1513 101.651 27.1513C104.402 27.1513 106.762 25.6833 107.658 23.0459H109.219C108.188 26.3227 105.323 28.4805 101.651 28.4805C96.9064 28.4805 93.4655 24.9051 93.4655 20.1603C93.4655 15.4154 96.9274 11.84 101.651 11.84C105.34 11.84 108.137 14.0399 109.219 17.2747H107.704C106.787 14.6625 104.427 13.1692 101.651 13.1692C97.8234 13.1692 94.9125 16.1726 94.9125 20.1603ZM110.039 12.1344H121.388V13.4174H116.412V28.1819H115.015V13.4258H110.039V12.1428V12.1344ZM138.398 20.1603C138.398 24.1942 141.309 27.1513 145.137 27.1513C147.888 27.1513 150.248 25.6833 151.144 23.0459H152.704C151.674 26.3227 148.805 28.4805 145.137 28.4805C140.392 28.4805 136.951 24.9051 136.951 20.1603C136.951 15.4154 140.413 11.84 145.137 11.84C148.826 11.84 151.623 14.0399 152.704 17.2747H151.19C150.273 14.6625 147.913 13.1692 145.137 13.1692C141.309 13.1692 138.398 16.1726 138.398 20.1603ZM160.398 12.1344L154.118 28.1819H155.586L157.168 24.1479H165.307L166.868 28.1819H168.357L162.097 12.1344H160.402H160.398ZM157.668 22.8397L161.151 13.7623H161.29L164.798 22.8397H157.668ZM182.133 16.7867C182.133 13.9684 180.185 12.1344 177.022 12.1344H171.751V28.1819H173.148V21.5315H177.161L180.896 28.1819H182.545L178.624 21.3969C180.597 20.9174 182.133 19.197 182.133 16.7909V16.7867ZM177.022 20.2696H173.148V13.3921H176.954C179.34 13.3921 180.669 14.8139 180.669 16.7867C180.669 19.0329 179.133 20.2696 177.022 20.2696ZM195 26.8947V28.1777H185.944V12.1386H194.815V13.4216H187.34V19.3821H193.805V20.644H187.34V26.9031H194.996L195 26.8947Z",
    fill: "#004659"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6887 1.50485L19.4789 8.71464L30.2473 19.4831L37.4571 12.2733C39.4636 10.2668 39.4636 7.01104 37.4571 5.00458L33.9574 1.50485C31.9509 -0.501615 28.6951 -0.501615 26.6887 1.50485Z",
    fill: "url(#paint0_linear_1019_33137)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.50485 33.9573L5.00458 37.457C7.01104 39.4635 10.2668 39.4635 12.2733 37.457L19.4831 30.2472L8.71464 19.4788L1.50485 26.6886C-0.501615 28.6951 -0.501615 31.9508 1.50485 33.9573Z",
    fill: "url(#paint1_linear_1019_33137)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9574 37.457L37.4571 33.9573C39.4636 31.9508 39.4636 28.6951 37.4571 26.6886L30.2473 19.4788L19.4789 30.2472L26.6887 37.457C28.6951 39.4635 31.9509 39.4635 33.9574 37.457Z",
    fill: "url(#paint2_linear_1019_33137)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00458 1.50485L1.50485 5.00458C-0.501615 7.01104 -0.501615 10.2668 1.50485 12.2733L8.71464 19.4831L19.4831 8.71464L12.2733 1.50485C10.2668 -0.501615 7.01104 -0.501615 5.00458 1.50485Z",
    fill: "url(#paint3_linear_1019_33137)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1019_33137",
    x1: 25.51,
    y1: 42.8447,
    x2: 20.5557,
    y2: -0.503464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#31A9E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007CC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1019_33137",
    x1: 7.79276,
    y1: 44.6341,
    x2: 2.83844,
    y2: 1.28594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008764"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#008966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#2EB692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1019_33137",
    x1: 2.97388,
    y1: 25.1784,
    x2: 46.322,
    y2: 20.2241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#9F6192"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#723B83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1019_33137",
    x1: 1.18443,
    y1: 7.46121,
    x2: 44.5326,
    y2: 2.50689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF4434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F26836"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLightRegular);
export default __webpack_public_path__ + "static/media/logo-light-regular.dd203d923d9f5538a4d4f0bb3c0842e9.svg";
export { ForwardRef as ReactComponent };